import pino from "pino";

// ---------------------------------------------------------------------------
// Structured Logger — Pino
// ---------------------------------------------------------------------------
// JSON an stdout. Vercel sammelt stdout automatisch ein.
// Sentry-Reporting passiert im Middleware-Layer (withLogger), nicht hier.
// Kein console.* — ESLint blockiert es sowieso.

const level = process.env.NODE_ENV === "production" ? "info" : "debug";

export const logger = pino({ level });

/** Request-scoped Child-Logger mit requestId, userId etc. */
export function createRequestLogger(
  bindings: Record<string, unknown>,
): pino.Logger {
  return logger.child(bindings);
}

export type Logger = pino.Logger;
